import ShokzMember from '@theme/shokz-member';

(function () {
  var LOG_PREFIX = '[CSP 四星护照]';
  var DRAFT_PREFIX = 'csp-star-passport-draft:';
  var REGISTER_MAX_TRIES = 3;
  var CHECK_EMAIL_TIMEOUT_MS = 3000;
  var MAX_AGE_YEARS = 100;
  var PROFILE_API_KEY = 'US39ZI942AA573A205BRX4D1FD3230A09A6';
  var YEARS_PER_PAGE = 21;
  var YEARS_PER_PAGE_MOBILE = 16;
  /** 线上填写截止：2026-10-13 15:00 北京时间（已停用，改由 Section settings「Open form filling」控制） */
  // var CAMPAIGN_END_AT_MS = Date.parse('2026-10-13T15:00:00+08:00');

  function isCampaignEnded(root) {
    var el = root || document.querySelector('[data-csp]');
    if (!el) return false;
    return el.getAttribute('data-csp-registration-open') !== 'true';
  }

  function applyCampaignEndedGate(root) {
    if (!root || !isCampaignEnded(root)) return false;
    root.classList.add('is-campaign-ended');
    log('活动填写已关闭（Section settings），禁用 Check Email / 提交 / Task CTA');

    var emailForm = root.querySelector('[data-csp-email-form]');
    if (emailForm) {
      var emailInput = emailForm.querySelector('input[name="email"]');
      var emailBtn = emailForm.querySelector('.csp-email__btn');
      if (emailInput) emailInput.disabled = true;
      if (emailBtn) emailBtn.disabled = true;
    }

    var submitBtn = root.querySelector('[data-csp-profile-submit-btn]');
    if (submitBtn) submitBtn.disabled = true;

    var part2Cta = root.querySelector('[data-csp-part2-cta]');
    if (part2Cta) {
      part2Cta.setAttribute('aria-disabled', 'true');
      part2Cta.classList.add('is-disabled');
    }

    var part3Cta = root.querySelector('[data-csp-part3-cta]');
    if (part3Cta) {
      part3Cta.setAttribute('aria-disabled', 'true');
      part3Cta.classList.add('is-disabled');
    }

    return true;
  }

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  }

  function logWarn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.warn.apply(console, args);
  }

  function logError() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.error.apply(console, args);
  }

  var GA4_CONTENT_TYPE = 'Membership_Page';
  var GA4_CONTENT_NAME = 'Chicago_Marathon';

  function pushGa4SelectContent(buttonName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: GA4_CONTENT_TYPE,
        content_name: GA4_CONTENT_NAME,
        button_name: buttonName,
      },
    });
    log('GA4 select_content', buttonName);
  }

  function pushGa4Subscribe(status, buttonName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'subscribe',
      event_parameters: {
        module: GA4_CONTENT_TYPE,
        status: status,
        button_name: buttonName,
      },
    });
    log('GA4 subscribe', buttonName, status);
  }

  function isMobileViewport() {
    return typeof window.matchMedia === 'function'
      && window.matchMedia('(max-width: 749px)').matches;
  }

  function isIosDevice() {
    var ua = navigator.userAgent || '';
    if (/iP(hone|ad|od)/.test(ua)) return true;
    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  }

  /** 本页禁用 iOS 聚焦小于 16px 输入框时的自动放大；不改字号，不影响其他页面 */
  function patchCspViewportMeta() {
    if (!isIosDevice()) return;
    var meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;
    var content = String(meta.getAttribute('content') || 'width=device-width,initial-scale=1');
    if (/maximum-scale\s*=/i.test(content)) {
      content = content.replace(/maximum-scale\s*=\s*[0-9.]+/i, 'maximum-scale=1');
    } else {
      content += ',maximum-scale=1';
    }
    meta.setAttribute('content', content);
  }

  patchCspViewportMeta();

  var pageScrollLockY = 0;

  /** 移动端 Part1 填写：锁住页面滚动，仅卡片内滚动 */
  function lockPageScroll() {
    if (!isMobileViewport()) return;
    if (document.body.classList.contains('csp-scroll-lock')) return;
    pageScrollLockY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('csp-scroll-lock');
    document.body.classList.add('csp-scroll-lock');
    document.body.style.top = '-' + pageScrollLockY + 'px';
  }

  function unlockPageScroll() {
    if (!document.body.classList.contains('csp-scroll-lock')) return;
    document.documentElement.classList.remove('csp-scroll-lock');
    document.body.classList.remove('csp-scroll-lock');
    document.body.style.top = '';
    try {
      window.scrollTo(0, pageScrollLockY);
    } catch (e) { /* ignore */ }
    pageScrollLockY = 0;
    clearCspKeyboardPad();
  }

  function clearCspKeyboardPad() {
    document.documentElement.style.removeProperty('--csp-keyboard-pad');
  }

  function getCspKeyboardInset() {
    var vv = window.visualViewport;
    if (!vv || typeof vv.height !== 'number') return 0;
    return Math.max(0, window.innerHeight - vv.height);
  }

  function syncCspKeyboardPad() {
    if (!isMobileViewport() || !document.querySelector('[data-csp].is-profile-expanded')) {
      clearCspKeyboardPad();
      return;
    }
    var inset = getCspKeyboardInset();
    if (inset > 60) {
      document.documentElement.style.setProperty('--csp-keyboard-pad', inset + 'px');
    } else {
      clearCspKeyboardPad();
    }
  }

  function isCspTextField(el) {
    if (!el || !el.tagName) return false;
    var tag = el.tagName.toUpperCase();
    if (tag === 'TEXTAREA' || el.isContentEditable) return true;
    if (tag !== 'INPUT') return false;
    var type = String(el.type || 'text').toLowerCase();
    return type !== 'hidden' && type !== 'checkbox' && type !== 'radio'
      && type !== 'button' && type !== 'submit' && type !== 'reset' && type !== 'file';
  }

  function scrollCspFieldAboveKeyboard(fieldEl) {
    if (!isMobileViewport() || !fieldEl) return;
    var scrollParent =
      fieldEl.closest('.csp-card.is-expanded') ||
      fieldEl.closest('[data-csp-panel]') ||
      null;
    if (!scrollParent) return;

    var vv = window.visualViewport;
    var visibleTop = vv && typeof vv.offsetTop === 'number' ? vv.offsetTop : 0;
    var visibleBottom = vv && typeof vv.height === 'number'
      ? visibleTop + vv.height
      : window.innerHeight;
    var headerH = parseFloat(document.documentElement.style.getPropertyValue('--header-height')) || 0;
    var topLimit = Math.max(visibleTop, headerH) + 12;
    var bottomLimit = visibleBottom - 12;
    var rect = fieldEl.getBoundingClientRect();
    var delta = 0;
    if (rect.bottom > bottomLimit) delta = rect.bottom - bottomLimit;
    else if (rect.top < topLimit) delta = rect.top - topLimit;
    if (!delta) return;
    scrollParent.scrollTop += delta;
  }

  function onCspTextFieldFocus(event) {
    var target = event.target;
    if (!isCspTextField(target) || !target.closest || !target.closest('[data-csp]')) return;
    window.setTimeout(function () {
      syncCspKeyboardPad();
      scrollCspFieldAboveKeyboard(target.closest('[data-csp-field]') || target);
    }, 350);
  }

  function bindCspKeyboardViewport() {
    if (bindCspKeyboardViewport.bound) return;
    bindCspKeyboardViewport.bound = true;
    var vv = window.visualViewport;
    if (vv) {
      vv.addEventListener('resize', function () {
        syncCspKeyboardPad();
        var active = document.activeElement;
        if (isCspTextField(active)) {
          scrollCspFieldAboveKeyboard(active.closest('[data-csp-field]') || active);
        }
      });
    }
    document.addEventListener('focusin', onCspTextFieldFocus);
    document.addEventListener('focusout', function () {
      window.setTimeout(syncCspKeyboardPad, 150);
    });
  }

  function scrollElIntoView(el, block) {
    if (!el || typeof el.scrollIntoView !== 'function') return;
    try {
      el.scrollIntoView({ behavior: 'smooth', block: block || 'nearest' });
    } catch (e) { /* ignore */ }
  }

  function scrollPanelToTop(root) {
    var panel = root ? root.querySelector('[data-csp-panel]') : null;
    scrollElIntoView(panel, 'start');
  }

  /**
   * 移动端：在卡片 overflow 容器内滚到字段+弹出层完整可见。
   * 日期/性别弹出层为 absolute，不能只 scrollIntoView 触发器。
   */
  function scrollFieldWithOverlayIntoView(fieldEl, overlaySelector) {
    if (!isMobileViewport() || !fieldEl) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var overlay = overlaySelector
          ? fieldEl.querySelector(overlaySelector)
          : null;
        if (overlay && overlay.hasAttribute('hidden')) overlay = null;

        var scrollParent =
          fieldEl.closest('.csp-card.is-expanded') ||
          fieldEl.closest('[data-csp-panel]') ||
          null;

        if (!scrollParent || scrollParent === document.body) {
          scrollElIntoView(overlay || fieldEl, 'nearest');
          return;
        }

        var parentRect = scrollParent.getBoundingClientRect();
        var fieldRect = fieldEl.getBoundingClientRect();
        var overlayRect = overlay ? overlay.getBoundingClientRect() : null;
        var top = Math.min(fieldRect.top, overlayRect ? overlayRect.top : fieldRect.top);
        var bottom = Math.max(
          fieldRect.bottom,
          overlayRect ? overlayRect.bottom : fieldRect.bottom
        );
        var pad = 16;
        var delta = 0;
        if (bottom > parentRect.bottom - pad) {
          delta = bottom - (parentRect.bottom - pad);
        } else if (top < parentRect.top + pad) {
          delta = top - (parentRect.top + pad);
        }
        if (!delta) return;
        var nextTop = scrollParent.scrollTop + delta;
        if (typeof scrollParent.scrollTo === 'function') {
          try {
            scrollParent.scrollTo({ top: nextTop, behavior: 'smooth' });
            return;
          } catch (e) { /* fallback below */ }
        }
        scrollParent.scrollTop = nextTop;
      });
    });
  }

  var MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  var GENDER_OPTIONS = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Non-binary/Third gender', value: 'Non-binary / Third gender' },
    { label: 'Prefer not to say', value: 'Prefer not to say' },
  ];

  var FIELD_LABELS_ZH = {
    first_name: '名 (First name)',
    last_name: '姓 (Last name)',
    email: '邮箱 (Email)',
    birthday: '生日 (Birthday)',
    gender: '性别 (Gender)',
    interests: '兴趣 (Interests)',
    consent_join: '入会协议勾选',
    consent_terms: '条款协议勾选',
    phone: '电话 (Phone)',
  };

  /** 与会员完善资料 usage_scenario 预设一致 */
  var INTEREST_OPTIONS = [
    'Running',
    'Cycling',
    'Hiking',
    'Swimming',
    'Gym/Strength',
    'Traveling',
    'Business Calls',
    'Pet Walking',
  ];

  var USAGE_SCENARIO_TO_INTEREST = {
    Running: 'Running',
    Cycling: 'Cycling',
    Hiking: 'Hiking',
    Swimming: 'Swimming',
    'Gym/Strength': 'Gym/Strength',
    Gym: 'Gym/Strength',
    'Gym / Strength': 'Gym/Strength',
    Traveling: 'Traveling',
    'Business Calls': 'Business Calls',
    'Pet Walking': 'Pet Walking',
  };

  function getApiBaseUrl() {
    return String((window.shokzApiSettings && window.shokzApiSettings.apiBaseUrl) || '').replace(/\/$/, '');
  }

  /** 主题可能改写 window.fetch，会员/抽奖等同用 originFetch */
  function cspFetch(input, init) {
    var rawFetch = window.originFetch || window.fetch;
    return rawFetch.call(window, input, init);
  }

  async function readJsonResponse(res) {
    if (!res) return {};
    if (typeof res.json === 'function') {
      try {
        return await res.json();
      } catch (e) {
        return {};
      }
    }
    // 少数环境下 fetch 已被包装成直接返回对象
    if (typeof res === 'object' && !('ok' in res && 'status' in res && 'headers' in res)) {
      return res;
    }
    return {};
  }

  function canonicalizeInterest(raw) {
    var key = String(raw || '').trim();
    if (!key) return '';
    if (USAGE_SCENARIO_TO_INTEREST[key]) return USAGE_SCENARIO_TO_INTEREST[key];
    if (INTEREST_OPTIONS.indexOf(key) !== -1) return key;
    return '';
  }

  function mapUsageScenariosToInterests(scenarios) {
    if (!Array.isArray(scenarios)) return [];
    var mapped = [];
    var seen = {};
    scenarios.forEach(function (raw) {
      var interest = canonicalizeInterest(raw);
      if (!interest) {
        log('兴趣映射：跳过无对应 chip 的 usage_scenario', raw);
        return;
      }
      if (seen[interest]) return;
      seen[interest] = true;
      mapped.push(interest);
    });
    return mapped;
  }

  function applyInterests(form, interestValues) {
    var list = (interestValues || []).map(canonicalizeInterest).filter(Boolean);
    form.querySelectorAll('[name="interests"]').forEach(function (cb) {
      cb.checked = list.indexOf(cb.value) !== -1;
    });
    log('兴趣标签已应用', list.length ? list : '（全部未选）');
  }

  function syncHeaderHeight() {
    var headers = document.querySelectorAll('.shopify-section-group-header-group');
    var height = 0;
    headers.forEach(function (el) {
      height += el.offsetHeight || 0;
    });
    if (!height) return;
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function formatDisplayDate(date) {
    if (!date) return '';
    return pad2(date.getMonth() + 1) + '/' + pad2(date.getDate()) + '/' + date.getFullYear();
  }

  function formatApiDate(display) {
    var d = parseBirthDate(display);
    return toApiDate(d);
  }

  function getBirthYearMin() {
    return new Date().getFullYear() - MAX_AGE_YEARS;
  }

  function getMinBirthDate() {
    var d = new Date();
    return new Date(d.getFullYear() - MAX_AGE_YEARS, d.getMonth(), d.getDate());
  }

  function getMaxBirthDate() {
    var d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function isBirthDateAllowed(date) {
    if (!date || Number.isNaN(date.getTime())) return false;
    var t = date.getTime();
    return t >= getMinBirthDate().getTime() && t <= getMaxBirthDate().getTime();
  }

  function toApiDate(date) {
    if (!date) return '';
    return date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate());
  }

  function birthdaysEqual(a, b) {
    if (!a || !b) return false;
    return toApiDate(a) === toApiDate(b);
  }

  function showCspToast(message) {
    var toast = document.getElementById('simple-toast');
    if (toast && typeof toast.show === 'function') {
      toast.show(message);
      return;
    }
    logWarn('Toast 不可用，降级日志', message);
  }

  function raceWithTimeout(promise, ms) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve({ timedOut: true, value: null });
      }, ms);
      promise.then(
        function (value) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve({ timedOut: false, value: value });
        },
        function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve({ timedOut: false, value: null, error: err });
        }
      );
    });
  }

  function setButtonLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('loading', on);
    btn.disabled = on;
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !on);
  }

  function parseBirthDate(raw) {
    if (!raw) return null;
    var str = String(raw).trim();
    var m = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (m) {
      return makeStrictDate(Number(m[1]), Number(m[2]), Number(m[3]));
    }
    m = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (m) {
      return makeStrictDate(Number(m[3]), Number(m[1]), Number(m[2]));
    }
    return null;
  }

  function makeStrictDate(year, month, day) {
    var d = new Date(year, month - 1, day);
    if (
      Number.isNaN(d.getTime()) ||
      d.getFullYear() !== year ||
      d.getMonth() !== month - 1 ||
      d.getDate() !== day
    ) {
      return null;
    }
    return d;
  }

  function maskBirthDateInput(raw) {
    var digits = String(raw || '').replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 2) return digits;
    if (digits.length <= 4) return digits.slice(0, 2) + '/' + digits.slice(2);
    return digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
  }

  function extractUsPhoneDigits(raw) {
    var str = String(raw || '').trim();
    var digits = str.replace(/\D/g, '');
    var hasCountryCode =
      digits.charAt(0) === '1' &&
      (digits.length >= 11 || str.charAt(0) === '+' || /^1[\s().-]/.test(str));
    if (hasCountryCode) digits = digits.slice(1);
    return digits.slice(0, 10);
  }

  function formatNationalUsPhone(digits) {
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  function maskUsPhoneInput(raw) {
    var trimmed = String(raw || '').trim();
    var digitsAll = trimmed.replace(/\D/g, '');
    var plus = trimmed.charAt(0) === '+';

    if (plus && digitsAll.length === 0) return '+';
    if (plus && digitsAll === '1') return '+1';

    var digits = extractUsPhoneDigits(raw);
    var national = formatNationalUsPhone(digits);
    if (plus) return national ? '+1 ' + national : '+1';
    return national;
  }

  function isUsPhoneNumber(raw) {
    var digits = extractUsPhoneDigits(raw);
    return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits);
  }

  function formatUsPhoneForField(raw) {
    var trimmed = String(raw || '').trim();
    if (!trimmed) return '';
    return isUsPhoneNumber(trimmed) ? maskUsPhoneInput(trimmed) : trimmed;
  }

  function countMaskCaretChars(str, keepPlus) {
    var n = 0;
    var i;
    var ch;
    for (i = 0; i < str.length; i += 1) {
      ch = str.charAt(i);
      if (/\d/.test(ch) || (keepPlus && ch === '+')) n += 1;
    }
    return n;
  }

  function caretIndexFromMaskChars(str, count, keepPlus) {
    if (count <= 0) return 0;
    var n = 0;
    var i;
    var ch;
    for (i = 0; i < str.length; i += 1) {
      ch = str.charAt(i);
      if (/\d/.test(ch) || (keepPlus && ch === '+')) {
        n += 1;
        if (n >= count) return i + 1;
      }
    }
    return str.length;
  }

  function applyMaskedInputValue(input, masked, keepPlus) {
    if (!input) return;
    var start = typeof input.selectionStart === 'number' ? input.selectionStart : String(input.value || '').length;
    var oldValue = String(input.value || '');
    if (oldValue === masked) return;
    var keep = countMaskCaretChars(oldValue.slice(0, start), keepPlus);
    input.value = masked;
    try {
      var pos = caretIndexFromMaskChars(masked, keep, keepPlus);
      input.setSelectionRange(pos, pos);
    } catch (e) { /* ignore */ }
  }

  function genderLabelFromValue(value) {
    if (!value) return '';
    if (value === 'No-binary/Third gender' || value === 'No-binary / Third gender') {
      value = 'Non-binary / Third gender';
    }
    var found = GENDER_OPTIONS.find(function (opt) {
      return opt.value === value || opt.label === value;
    });
    return found ? found.label : value;
  }

  function genderValueFromAny(raw) {
    if (!raw) return '';
    if (raw === 'No-binary/Third gender' || raw === 'No-binary / Third gender') {
      raw = 'Non-binary / Third gender';
    }
    var found = GENDER_OPTIONS.find(function (opt) {
      return opt.value === raw || opt.label === raw;
    });
    return found ? found.value : raw;
  }

  function setFieldError(fieldEl, on) {
    if (!fieldEl) return;
    fieldEl.classList.toggle('is-error', on);
    var err = fieldEl.querySelector('.csp-field__error');
    if (err) {
      if (on) err.removeAttribute('hidden');
      else err.setAttribute('hidden', '');
    }
  }

  function clearFormErrors(form) {
    form.querySelectorAll('[data-csp-field]').forEach(function (field) {
      setFieldError(field, false);
    });
    var alertEl = form.closest('[data-csp-profile-form]');
    var alert = alertEl ? alertEl.querySelector('[data-csp-profile-alert]') : null;
    if (alert) alert.setAttribute('hidden', '');
    form.querySelectorAll('[data-csp-consent-error]').forEach(function (el) {
      el.setAttribute('hidden', '');
    });
  }

  function draftKey(email) {
    return DRAFT_PREFIX + String(email || '').trim().toLowerCase();
  }

  function loadDraft(email) {
    try {
      var raw = localStorage.getItem(draftKey(email));
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      logWarn('读取草稿失败', e);
      return null;
    }
  }

  function saveDraft(email, data) {
    try {
      localStorage.setItem(draftKey(email), JSON.stringify(data));
      log('草稿已保存', email, data && {
        part1Complete: data.part1Complete,
        part2Complete: data.part2Complete,
        part3Complete: data.part3Complete,
      });
    } catch (e) {
      logWarn('保存草稿失败', e);
    }
  }

  function mergeAndSaveDraft(email, patch) {
    if (!email) return;
    var prev = loadDraft(email) || {};
    saveDraft(email, Object.assign({}, prev, patch || {}, { updatedAt: Date.now() }));
  }

  function clearDraft(email) {
    try {
      localStorage.removeItem(draftKey(email));
      log('草稿已清除', email);
    } catch (e) {
      logWarn('清除草稿失败', e);
    }
  }

  function isRegisterSuccess(res) {
    if (!res || typeof res !== 'object') return false;
    if (Number(res.code) === 0) return true;
    var msg = String(res.message || res.msg || '').toLowerCase();
    return msg.indexOf('success') !== -1 || msg.indexOf('already') !== -1;
  }

  async function registerWithRetry(email, maxTries) {
    var tries = maxTries || REGISTER_MAX_TRIES;
    var lastRes = null;
    var i;
    for (i = 1; i <= tries; i += 1) {
      log('注册会员 第 ' + i + '/' + tries + ' 次', email);
      try {
        lastRes = await ShokzMember.registerShopifyMember(email);
        log('注册响应', lastRes);
        if (isRegisterSuccess(lastRes)) {
          log('注册成功');
          return { ok: true, res: lastRes };
        }
        logWarn('注册业务未成功', lastRes);
      } catch (err) {
        logError('注册请求异常', err);
        lastRes = err;
      }
    }
    return { ok: false, res: lastRes };
  }

  async function fetchProfileToken() {
    var baseUrl = getApiBaseUrl();
    if (!baseUrl) throw new Error('缺少 apiBaseUrl');
    log('请求 get-token…', baseUrl);
    var res;
    try {
      res = await cspFetch(baseUrl + '/api/v1/get-token', {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'X-Site': 'us',
          'Api-Key': PROFILE_API_KEY,
        },
      });
    } catch (err) {
      logError('get-token 网络失败', err);
      throw new Error('Network error while getting token. Please try again.');
    }
    if (!res || !res.ok) throw new Error('get-token HTTP ' + (res && res.status));
    var json = await readJsonResponse(res);
    if (!json || Number(json.code) !== 0 || !json.data || !json.data.token) {
      throw new Error('get-token 无效响应');
    }
    return {
      token: String(json.data.token),
      timestamp: String(json.data.timestamp),
    };
  }

  async function pushChicagoProfile(auth, payload) {
    var baseUrl = getApiBaseUrl();
    if (!baseUrl) throw new Error('缺少 apiBaseUrl');
    log('推送 chicago-four-star-profile…', baseUrl, payload);
    var res;
    try {
      res = await cspFetch(baseUrl + '/api/v1/us/chicago-four-star-profile', {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Site': 'us',
          'Api-Key': PROFILE_API_KEY,
          'X-Verify-Token': auth.token,
          Timestamp: auth.timestamp,
        },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      logError('资料推送网络失败', err);
      throw new Error('Network error while submitting profile. Please try again.');
    }
    var json = await readJsonResponse(res);
    log('资料推送响应', res && res.status, json);
    if (!res || !res.ok || Number(json.code) !== 0) {
      throw new Error((json && (json.message || json.msg)) || 'Profile submit failed');
    }
    return json;
  }

  async function pushChicagoOfflineEvent(auth, email) {
    var baseUrl = getApiBaseUrl();
    if (!baseUrl) throw new Error('缺少 apiBaseUrl');
    var payload = { email: String(email || '').trim() };
    log('推送 chicago-four-star-offline-event…', baseUrl, payload);
    var res;
    try {
      res = await cspFetch(baseUrl + '/api/v1/us/chicago-four-star-offline-event', {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Site': 'us',
          'Api-Key': PROFILE_API_KEY,
          'X-Verify-Token': auth.token,
          Timestamp: auth.timestamp,
        },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      logError('offline-event 网络失败', err);
      throw new Error('Network error while submitting offline event. Please try again.');
    }
    var json = await readJsonResponse(res);
    log('offline-event 响应', res && res.status, json);
    if (!res || !res.ok || Number(json.code) !== 0) {
      throw new Error((json && (json.message || json.msg)) || 'Offline event submit failed');
    }
    return json;
  }

  function initDatepicker(datepickerEl) {
    log('初始化日期选择器（含年份快捷 / 手动输入，最大 ' + MAX_AGE_YEARS + ' 岁）');
    var trigger = datepickerEl.querySelector('[data-csp-datepicker-trigger]');
    var textInput = datepickerEl.querySelector('[data-csp-datepicker-input]');
    var valueInput = datepickerEl.querySelector('[data-csp-datepicker-value]');
    var popover = datepickerEl.querySelector('[data-csp-datepicker-popover]');
    var monthLabelEl = datepickerEl.querySelector('[data-csp-datepicker-month-label]');
    var yearBtn = datepickerEl.querySelector('[data-csp-datepicker-year-btn]');
    var weekdays = datepickerEl.querySelector('[data-csp-datepicker-weekdays]');
    var grid = datepickerEl.querySelector('[data-csp-datepicker-grid]');
    var prevBtn = datepickerEl.querySelector('[data-csp-datepicker-prev]');
    var nextBtn = datepickerEl.querySelector('[data-csp-datepicker-next]');

    var yearMin = getBirthYearMin();
    var yearMax = new Date().getFullYear();
    var view = new Date();
    view.setDate(1);
    var selected = null;
    var readonly = false;
    var mode = 'days';
    var yearPageStart = 0;

    function yearsPerPage() {
      return isMobileViewport() ? YEARS_PER_PAGE_MOBILE : YEARS_PER_PAGE;
    }

    function refreshYearBounds() {
      yearMin = getBirthYearMin();
      yearMax = new Date().getFullYear();
    }

    function alignYearPage(year) {
      var size = yearsPerPage();
      refreshYearBounds();
      var start = Math.floor(year / size) * size;
      if (start < yearMin) start = yearMin;
      var maxStart = Math.floor(yearMax / size) * size;
      if (maxStart < yearMin) maxStart = yearMin;
      if (start > maxStart) start = maxStart;
      return start;
    }

    yearPageStart = alignYearPage(view.getFullYear());

    function setMode(next) {
      mode = next;
      datepickerEl.classList.toggle('is-years-mode', mode === 'years');
      if (weekdays) weekdays.hidden = mode === 'years';
      if (grid) grid.classList.toggle('csp-datepicker__grid--years', mode === 'years');
    }

    function close() {
      if (!datepickerEl.classList.contains('is-open')) return;
      datepickerEl.classList.remove('is-open');
      if (popover) popover.setAttribute('hidden', '');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      setMode('days');
      log('日期选择器：已关闭');
    }

    function open() {
      if (readonly) {
        logWarn('日期选择器：只读，禁止打开');
        return;
      }
      refreshYearBounds();
      datepickerEl.classList.add('is-open');
      if (popover) popover.removeAttribute('hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      setMode('days');
      render();
      scrollFieldWithOverlayIntoView(datepickerEl, '[data-csp-datepicker-popover]');
      log('日期选择器：已打开');
    }

    function syncTextInput(display, opts) {
      if (!textInput) return;
      if (opts && opts.skipText) return;
      if (textInput.value === display) return;
      textInput.value = display;
    }

    function setValue(date, opts) {
      if (date && !isBirthDateAllowed(date) && !(opts && opts.force)) {
        logWarn('日期选择器：超出年龄范围，已忽略', formatDisplayDate(date));
        return false;
      }
      selected = date;
      if (date) {
        view = new Date(date.getFullYear(), date.getMonth(), 1);
        if (valueInput) valueInput.value = formatDisplayDate(date);
        syncTextInput(formatDisplayDate(date), opts);
        datepickerEl.classList.add('has-value');
        log('日期选择器：设置日期', formatDisplayDate(date));
      } else {
        if (valueInput) valueInput.value = '';
        syncTextInput('', opts);
        datepickerEl.classList.remove('has-value');
        log('日期选择器：已清空');
      }
      if (!(opts && opts.keepOpen)) close();
      setFieldError(datepickerEl, false);
      return true;
    }

    function commitTypedDate() {
      if (readonly || !textInput) return Boolean(selected);
      var raw = String(textInput.value || '').trim();
      if (!raw) {
        setValue(null, { keepOpen: true, force: true, skipText: true });
        return false;
      }
      var date = parseBirthDate(raw);
      if (!date || !isBirthDateAllowed(date)) {
        selected = null;
        if (valueInput) valueInput.value = '';
        datepickerEl.classList.remove('has-value');
        setFieldError(datepickerEl, true);
        logWarn('日期选择器：手动输入无效', raw);
        return false;
      }
      setValue(date, { keepOpen: true, skipText: true });
      syncTextInput(formatDisplayDate(date));
      if (datepickerEl.classList.contains('is-open')) render();
      return true;
    }

    function updateHeader() {
      if (monthLabelEl) monthLabelEl.textContent = MONTH_NAMES[view.getMonth()] + ' ';
      if (yearBtn) {
        if (mode === 'years') {
          yearBtn.textContent = yearPageStart + ' – ' + (yearPageStart + yearsPerPage() - 1);
        } else {
          yearBtn.textContent = String(view.getFullYear());
        }
      }
    }

    function renderDays() {
      if (!grid) return;
      grid.innerHTML = '';
      var firstDow = new Date(view.getFullYear(), view.getMonth(), 1).getDay();
      var daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      var i;
      for (i = 0; i < firstDow; i += 1) {
        var empty = document.createElement('button');
        empty.type = 'button';
        empty.className = 'csp-datepicker__day';
        empty.disabled = true;
        empty.setAttribute('aria-hidden', 'true');
        grid.appendChild(empty);
      }
      for (i = 1; i <= daysInMonth; i += 1) {
        var dayDate = new Date(view.getFullYear(), view.getMonth(), i);
        var allowed = isBirthDateAllowed(dayDate);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'csp-datepicker__day';
        btn.textContent = String(i);
        if (!allowed) btn.disabled = true;
        if (
          selected &&
          selected.getFullYear() === view.getFullYear() &&
          selected.getMonth() === view.getMonth() &&
          selected.getDate() === i
        ) {
          btn.classList.add('is-selected');
        }
        if (allowed) {
          btn.addEventListener('click', function (day) {
            return function () {
              setValue(new Date(view.getFullYear(), view.getMonth(), day));
            };
          }(i));
        }
        grid.appendChild(btn);
      }
    }

    function renderYears() {
      if (!grid) return;
      grid.innerHTML = '';
      refreshYearBounds();
      var y;
      for (y = yearPageStart; y < yearPageStart + yearsPerPage(); y += 1) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'csp-datepicker__year';
        btn.textContent = String(y);
        if (y < yearMin || y > yearMax) btn.classList.add('is-disabled');
        if (selected && selected.getFullYear() === y) btn.classList.add('is-selected');
        else if (!selected && view.getFullYear() === y) btn.classList.add('is-selected');
        btn.addEventListener('click', function (year) {
          return function (event) {
            event.stopPropagation();
            if (year < yearMin || year > yearMax) return;
            view = new Date(year, view.getMonth(), 1);
            log('日期选择器：选择年份', year);
            setMode('days');
            render();
          };
        }(y));
        grid.appendChild(btn);
      }
    }

    function render() {
      updateHeader();
      if (mode === 'years') renderYears();
      else renderDays();
    }

    if (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (readonly) return;
        if (datepickerEl.classList.contains('is-open')) close();
        else open();
      });
    }
    if (textInput) {
      textInput.addEventListener('input', function () {
        if (readonly) return;
        var masked = maskBirthDateInput(textInput.value);
        applyMaskedInputValue(textInput, masked, false);
        datepickerEl.classList.toggle('has-value', Boolean(masked));
        setFieldError(datepickerEl, false);
        if (masked.length === 10) commitTypedDate();
      });
      textInput.addEventListener('blur', function () {
        if (readonly) return;
        commitTypedDate();
      });
      textInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        if (commitTypedDate()) close();
      });
    }
    var fieldEl = datepickerEl.querySelector('[data-csp-datepicker-field]');
    if (fieldEl) {
      fieldEl.addEventListener('click', function (event) {
        if (readonly) return;
        if (trigger && (event.target === trigger || trigger.contains(event.target))) return;
        if (!datepickerEl.classList.contains('is-open')) open();
        if (textInput) textInput.focus();
      });
    }
    if (yearBtn) {
      yearBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        if (readonly) return;
        if (mode === 'years') {
          setMode('days');
        } else {
          refreshYearBounds();
          yearPageStart = alignYearPage(view.getFullYear());
          setMode('years');
        }
        render();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        if (mode === 'years') {
          yearPageStart -= yearsPerPage();
          if (yearPageStart < yearMin) yearPageStart = yearMin;
        } else {
          view.setMonth(view.getMonth() - 1);
          if (view.getFullYear() < yearMin) {
            view = new Date(yearMin, 0, 1);
          }
        }
        render();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        if (mode === 'years') {
          yearPageStart += yearsPerPage();
          var maxStart = Math.floor(yearMax / yearsPerPage()) * yearsPerPage();
          if (yearPageStart > maxStart) yearPageStart = maxStart;
        } else {
          view.setMonth(view.getMonth() + 1);
          if (view.getFullYear() > yearMax) {
            view = new Date(yearMax, 11, 1);
          }
        }
        render();
      });
    }

    document.addEventListener('click', function (event) {
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      if (path.indexOf(datepickerEl) !== -1) return;
      if (datepickerEl.contains(event.target)) return;
      close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    return {
      setValue: setValue,
      getValue: function () {
        return valueInput ? valueInput.value : '';
      },
      setReadonly: function (on) {
        readonly = Boolean(on);
        datepickerEl.classList.toggle('is-readonly', readonly);
        if (trigger) {
          trigger.setAttribute('aria-disabled', readonly ? 'true' : 'false');
          trigger.disabled = readonly;
          trigger.tabIndex = readonly ? -1 : 0;
        }
        if (textInput) {
          textInput.readOnly = readonly;
          textInput.tabIndex = readonly ? -1 : 0;
        }
        if (readonly) close();
      },
      clear: function () {
        setValue(null, { force: true });
      },
      commitInput: commitTypedDate,
    };
  }

  function initGender(selectEl) {
    var trigger = selectEl.querySelector('[data-csp-gender-trigger]');
    var label = selectEl.querySelector('[data-csp-gender-label]');
    var valueInput = selectEl.querySelector('[data-csp-gender-value]');
    var list = selectEl.querySelector('[data-csp-gender-list]');

    function close() {
      if (!selectEl.classList.contains('is-open')) return;
      selectEl.classList.remove('is-open');
      if (list) list.setAttribute('hidden', '');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function open() {
      selectEl.classList.add('is-open');
      if (list) list.removeAttribute('hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      scrollFieldWithOverlayIntoView(selectEl, '[data-csp-gender-list]');
    }

    function setValue(value) {
      var submitValue = genderValueFromAny(value);
      var display = genderLabelFromValue(submitValue);
      if (valueInput) valueInput.value = submitValue || '';
      if (label) label.textContent = submitValue ? display : 'Gender *';
      selectEl.classList.toggle('has-value', Boolean(submitValue));
      setFieldError(selectEl, false);
      close();
    }

    if (trigger) {
      trigger.addEventListener('click', function () {
        if (selectEl.classList.contains('is-open')) close();
        else open();
      });
    }
    if (list) {
      list.querySelectorAll('[role="option"]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          setValue(opt.getAttribute('data-value') || '');
        });
      });
    }
    document.addEventListener('click', function (event) {
      if (!selectEl.contains(event.target)) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    return {
      setValue: setValue,
      getValue: function () {
        return valueInput ? valueInput.value : '';
      },
      clear: function () {
        setValue('');
      },
    };
  }

  function setConsentChecked(root, name, checked) {
    var input = root.querySelector('[data-csp-consent="' + name + '"]');
    if (input) input.checked = Boolean(checked);
  }

  function setEmailReadonly(form, email) {
    var emailInput = form.querySelector('[name="email"]');
    if (!emailInput) return;
    emailInput.value = email || '';
    emailInput.readOnly = true;
    emailInput.setAttribute('aria-readonly', 'true');
    var field = emailInput.closest('[data-csp-field]');
    if (field) field.classList.add('is-readonly');
    log('邮箱已锁定为只读', email);
  }

  function expandProfile(card, profileForm) {
    card.classList.add('is-expanded');
    card.classList.remove('is-complete');
    profileForm.removeAttribute('hidden');
    var root = card.closest('[data-csp]');
    if (root) root.classList.add('is-profile-expanded');
    syncHeaderHeight();
    if (isMobileViewport()) {
      try {
        window.scrollTo({ top: 0, behavior: 'auto' });
      } catch (e) {
        window.scrollTo(0, 0);
      }
      lockPageScroll();
      bindCspKeyboardViewport();
      // iOS：锁滚动后再量一次 header（含公告栏），并强制一次 reflow
      window.requestAnimationFrame(function () {
        syncHeaderHeight();
      });
    }
    log('Card 1 已展开资料表单');
  }

  function applyCard1CompleteUI(root, card1, profileForm) {
    if (root) root.classList.remove('is-profile-expanded');
    unlockPageScroll();
    if (card1) {
      card1.classList.remove('is-expanded');
      card1.classList.add('is-complete');
      var card1Done = card1.querySelector('[data-csp-card1-done]');
      if (card1Done) card1Done.removeAttribute('hidden');
    }
    if (profileForm) profileForm.setAttribute('hidden', '');
  }

  function applyCard2ActiveUI(root) {
    var card2 = root ? root.querySelector('[data-csp-card-2]') : null;
    if (!card2) return null;
    card2.classList.add('is-active');
    card2.classList.remove('is-complete');
    var idle = card2.querySelector('[data-csp-card2-idle]');
    var active = card2.querySelector('[data-csp-card2-active]');
    var done = card2.querySelector('[data-csp-card2-done]');
    if (idle) idle.setAttribute('hidden', '');
    if (active) active.removeAttribute('hidden');
    if (done) done.setAttribute('hidden', '');
    return card2;
  }

  function applyCard2CompleteUI(root) {
    var card2 = root ? root.querySelector('[data-csp-card-2]') : null;
    if (!card2) return null;
    card2.classList.remove('is-active');
    card2.classList.add('is-complete');
    var idle = card2.querySelector('[data-csp-card2-idle]');
    var active = card2.querySelector('[data-csp-card2-active]');
    var done = card2.querySelector('[data-csp-card2-done]');
    if (idle) idle.setAttribute('hidden', '');
    if (active) active.setAttribute('hidden', '');
    if (done) done.removeAttribute('hidden');
    return card2;
  }

  function applyCard3ActiveUI(root) {
    var card3 = root ? root.querySelector('[data-csp-card-3]') : null;
    if (!card3) return null;
    card3.classList.add('is-active');
    card3.classList.remove('is-complete');
    var idle = card3.querySelector('[data-csp-card3-idle]');
    var active = card3.querySelector('[data-csp-card3-active]');
    var done = card3.querySelector('[data-csp-card3-done]');
    if (idle) idle.setAttribute('hidden', '');
    if (active) active.removeAttribute('hidden');
    if (done) done.setAttribute('hidden', '');
    return card3;
  }

  function applyCard3CompleteUI(root) {
    var card3 = root ? root.querySelector('[data-csp-card-3]') : null;
    if (!card3) return null;
    card3.classList.remove('is-active');
    card3.classList.add('is-complete');
    var idle = card3.querySelector('[data-csp-card3-idle]');
    var active = card3.querySelector('[data-csp-card3-active]');
    var done = card3.querySelector('[data-csp-card3-done]');
    if (idle) idle.setAttribute('hidden', '');
    if (active) active.setAttribute('hidden', '');
    if (done) done.removeAttribute('hidden');
    return card3;
  }

  function scrollToCard(card) {
    if (card && typeof card.scrollIntoView === 'function') {
      try {
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch (e) { /* ignore */ }
    }
  }

  /** 资料提交成功 → 退出 Part1 表单全屏态，展示 Part1 完成态 + Part2 进行中 */
  function enterPart2(root, card1, profileForm, setCurrentStep, options) {
    var opts = options || {};
    applyCard1CompleteUI(root, card1, profileForm);
    applyCard2ActiveUI(root);
    if (typeof setCurrentStep === 'function') setCurrentStep(2);
    if (!opts.skipScroll) {
      // PC/MB：表单提交成功后平滑滚到 panel 顶部
      scrollPanelToTop(root);
    }
    log('资料完成，进入 Part 2（卡片无展开收起交互）');
  }

  /** Part 2 CTA → 完成态 + 展示 Part3 进行中 + 时间轴 Step 3 */
  function completePart2(root, setCurrentStep, options) {
    var opts = options || {};
    applyCard2CompleteUI(root);
    if (typeof setCurrentStep === 'function') setCurrentStep(3);
    applyCard3ActiveUI(root);
    if (!opts.skipScroll) {
      if (isMobileViewport()) scrollPanelToTop(root);
      else scrollToCard(root ? root.querySelector('[data-csp-card-3]') : null);
    }
    log('Part 2 完成，进入 Part 3');
  }

  /** 展示 Part 3 进行中（无卡片展开收起交互） */
  function enterPart3(root, options) {
    var opts = options || {};
    applyCard3ActiveUI(root);
    if (!opts.skipScroll) {
      if (isMobileViewport()) scrollPanelToTop(root);
      else scrollToCard(root ? root.querySelector('[data-csp-card-3]') : null);
    }
  }

  /** Part 3 CTA → 完成态 + 时间轴 Step 4；2s 后打开凭证弹窗 */
  function completePart3(root, setCurrentStep, openPopup, options) {
    var opts = options || {};
    applyCard3CompleteUI(root);
    if (typeof setCurrentStep === 'function') setCurrentStep(4);
    if (!opts.skipScroll && isMobileViewport()) scrollPanelToTop(root);
    log('Part 3 完成');
    if (typeof openPopup === 'function') {
      if (opts.immediatePopup) {
        openPopup();
      } else {
        window.setTimeout(function () {
          openPopup();
        }, 2000);
      }
    }
  }

  /** 按本机草稿恢复 Part 1/2/3 UI；有进度返回 true */
  function restoreProgressFromDraft(root, card1, profileForm, draft, setCurrentStep, openPopup) {
    if (!draft || !draft.part1Complete) return false;
    applyCard1CompleteUI(root, card1, profileForm);
    if (draft.part3Complete) {
      applyCard2CompleteUI(root);
      completePart3(root, setCurrentStep, openPopup, { immediatePopup: true });
      log('从本机恢复：Part 1/2/3 均已完成');
      return true;
    }
    if (draft.part2Complete) {
      applyCard2CompleteUI(root);
      if (typeof setCurrentStep === 'function') setCurrentStep(3);
      enterPart3(root, { skipScroll: true });
      log('从本机恢复：Part 1/2 已完成，进入 Part 3');
      return true;
    }
    applyCard2ActiveUI(root);
    if (typeof setCurrentStep === 'function') setCurrentStep(2);
    log('从本机恢复：Part 1 已完成，进入 Part 2');
    return true;
  }

  function openCredentialPopup(root, profileForm, state) {
    var popup = root ? root.querySelector('[data-csp-popup]') : null;
    if (!popup) return;

    var nameEl = popup.querySelector('[data-csp-popup-name]');
    var emailEl = popup.querySelector('[data-csp-popup-email]');
    var firstName = '';
    var email = (state && state.checkedEmail) || '';
    if (profileForm) {
      var firstInput = profileForm.querySelector('[name="first_name"]');
      var emailInput = profileForm.querySelector('[name="email"]');
      if (firstInput) firstName = String(firstInput.value || '').trim();
      if (!email && emailInput) email = String(emailInput.value || '').trim();
    }
    if (nameEl) nameEl.textContent = firstName || '—';
    if (emailEl) emailEl.textContent = email || '—';

    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('is-open');
    var panel = root.querySelector('[data-csp-panel]');
    if (panel) {
      panel.classList.add('is-popup-open');
      if (typeof panel.scrollIntoView === 'function') {
        try {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) { /* ignore */ }
      }
    }
    log('凭证弹窗已打开', { firstName: firstName, email: email });
  }

  function waitFontsReady() {
    if (document.fonts && document.fonts.ready) {
      return document.fonts.ready.then(
        function () {},
        function () {}
      );
    }
    return Promise.resolve();
  }

  var htmlToImageApi = null;
  var HTML_TO_IMAGE_CDN = 'https://cdn.jsdelivr.net/npm/html-to-image@1.11.13/+esm';

  function ensureHtmlToImage() {
    if (htmlToImageApi) return Promise.resolve(htmlToImageApi);
    return import(HTML_TO_IMAGE_CDN).then(function (mod) {
      htmlToImageApi = mod;
      return mod;
    });
  }

  function fillCredentialCard(card, firstName, email) {
    if (!card) return;
    var nameEls = card.querySelectorAll('[data-csp-cred-name]');
    var emailEls = card.querySelectorAll('[data-csp-cred-email]');
    nameEls.forEach(function (el) {
      el.textContent = firstName || '—';
    });
    emailEls.forEach(function (el) {
      el.textContent = email || '—';
    });
  }

  function waitImages(el) {
    var imgs = el ? Array.prototype.slice.call(el.querySelectorAll('img')) : [];
    if (!imgs.length) return Promise.resolve();
    return Promise.all(
      imgs.map(function (img) {
        if (img.complete && img.naturalWidth) return Promise.resolve();
        return new Promise(function (resolve) {
          var done = function () {
            resolve();
          };
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
      })
    );
  }

  function isSafariLike() {
    var ua = navigator.userAgent || '';
    return /iP(hone|ad|od)|Macintosh/.test(ua) && /WebKit/.test(ua) && !/Chrome|CriOS|Edg|Firefox/.test(ua);
  }

  function loadCorsImage(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        reject(new Error('empty image src'));
        return;
      }
      if (src.indexOf('data:') === 0) {
        var dataImg = new Image();
        dataImg.onload = function () {
          resolve(dataImg);
        };
        dataImg.onerror = reject;
        dataImg.src = src;
        return;
      }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject(new Error('cors image load failed'));
      };
      // bust cache so Safari uses CORS response, not a tainted cached copy
      img.src = src + (src.indexOf('?') >= 0 ? '&' : '?') + '_csp=' + Date.now();
    });
  }

  /** 优先用页面已解码的 img（CORS 干净则可直接画）；失败再重新拉 */
  function resolveDrawableImage(imgEl) {
    if (!imgEl) return Promise.resolve(null);
    var src = imgEl.currentSrc || imgEl.src;
    if (!src) return Promise.resolve(null);

    if (imgEl.complete && imgEl.naturalWidth) {
      try {
        var probe = document.createElement('canvas');
        probe.width = 2;
        probe.height = 2;
        var pctx = probe.getContext('2d');
        pctx.drawImage(imgEl, 0, 0, 2, 2);
        // 触发污染检测
        probe.toDataURL('image/png');
        return Promise.resolve(imgEl);
      } catch (err) {
        /* tainted — fall through */
      }
    }

    return loadCorsImage(src).catch(function () {
      return null;
    });
  }

  function drawImageCover(ctx, img, x, y, w, h) {
    var sw = img.naturalWidth || img.width;
    var sh = img.naturalHeight || img.height;
    if (!sw || !sh || w <= 0 || h <= 0) return;
    var scale = Math.max(w / sw, h / sh);
    var dw = sw * scale;
    var dh = sh * scale;
    var dx = x + (w - dw) / 2;
    var dy = y + (h - dh) / 2;
    ctx.drawImage(img, dx, dy, dw, dh);
  }

  function roundRectPath(ctx, x, y, w, h, r) {
    var radius = Math.max(0, Math.min(r, w / 2, h / 2));
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.arcTo(x + w, y, x + w, y + h, radius);
    ctx.arcTo(x + w, y + h, x, y + h, radius);
    ctx.arcTo(x, y + h, x, y, radius);
    ctx.arcTo(x, y, x + w, y, radius);
    ctx.closePath();
  }

  function relativeBox(el, rootEl) {
    var rootRect = rootEl.getBoundingClientRect();
    var rect = el.getBoundingClientRect();
    var scaleX = rootEl.offsetWidth ? rootRect.width / rootEl.offsetWidth : 1;
    var scaleY = rootEl.offsetHeight ? rootRect.height / rootEl.offsetHeight : 1;
    return {
      x: (rect.left - rootRect.left) / (scaleX || 1),
      y: (rect.top - rootRect.top) / (scaleY || 1),
      w: rect.width / (scaleX || 1),
      h: rect.height / (scaleY || 1),
    };
  }

  /** Safari 需多次截图才能把 foreignObject 内容画全；此处用于无图文字层 */
  function captureDomLayer(htmlToImage, node, opts) {
    var maxPasses = isSafariLike() ? 4 : 1;
    var pass = 0;
    var prevLen = -1;

    function run() {
      pass += 1;
      var capture = htmlToImage.toPng
        ? htmlToImage.toPng(node, opts)
        : htmlToImage.toJpeg(node, opts);
      return capture.then(function (dataUrl) {
        var len = dataUrl ? dataUrl.length : 0;
        if (pass >= maxPasses || len === prevLen) return dataUrl;
        prevLen = len;
        return new Promise(function (resolve) {
          window.setTimeout(function () {
            resolve(run());
          }, 120);
        });
      });
    }

    return run();
  }

  function composeCredentialPng(card, exportW, exportH, textDataUrl, bgBitmap, mapBitmap, mapBox, cardRadius) {
    var scale = 2;
    var canvas = document.createElement('canvas');
    canvas.width = Math.round(exportW * scale);
    canvas.height = Math.round(exportH * scale);
    var ctx = canvas.getContext('2d');
    if (!ctx) return Promise.reject(new Error('canvas unsupported'));

    ctx.scale(scale, scale);
    ctx.fillStyle = '#000b1c';
    ctx.fillRect(0, 0, exportW, exportH);

    if (bgBitmap) {
      ctx.save();
      roundRectPath(ctx, 0, 0, exportW, exportH, cardRadius || 0);
      ctx.clip();
      drawImageCover(ctx, bgBitmap, 0, 0, exportW, exportH);
      ctx.restore();
    }

    if (mapBitmap && mapBox && mapBox.w > 0 && mapBox.h > 0) {
      ctx.save();
      roundRectPath(ctx, mapBox.x, mapBox.y, mapBox.w, mapBox.h, 4);
      ctx.clip();
      drawImageCover(ctx, mapBitmap, mapBox.x, mapBox.y, mapBox.w, mapBox.h);
      ctx.restore();
    }

    return new Promise(function (resolve, reject) {
      var overlay = new Image();
      overlay.onload = function () {
        ctx.drawImage(overlay, 0, 0, exportW, exportH);
        if (typeof canvas.toBlob === 'function') {
          canvas.toBlob(
            function (blob) {
              if (!blob) {
                reject(new Error('Failed to export image'));
                return;
              }
              resolve(blob);
            },
            'image/png'
          );
        } else {
          resolve(canvas.toDataURL('image/png'));
        }
      };
      overlay.onerror = function () {
        reject(new Error('overlay decode failed'));
      };
      overlay.src = textDataUrl;
    });
  }

  function downloadDataUrl(dataUrl, filename) {
    var a = document.createElement('a');
    a.href = dataUrl;
    a.download = filename || 'chicago-star-passport.png';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  function downloadBlob(blob, filename) {
    var url = URL.createObjectURL(blob);
    downloadDataUrl(url, filename);
    window.setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 1500);
  }

  function findCredentialStage(root) {
    if (root) {
      var inRoot = root.querySelector('[data-csp-credential-stage]');
      if (inRoot) return inRoot;
      var section = root.closest('.section-2026chicago-star-passport');
      if (section) {
        var inSection = section.querySelector('[data-csp-credential-stage]');
        if (inSection) return inSection;
      }
    }
    return document.querySelector('[data-csp-credential-stage]');
  }

  function saveCredentialImage(root, firstName, email) {
    var stage = findCredentialStage(root);
    var variant = isMobileViewport() ? 'mb' : 'pc';
    var card = stage
      ? stage.querySelector('[data-csp-credential="' + variant + '"]')
      : null;
    if (!card) {
      return Promise.reject(new Error('Credential card not found'));
    }

    var exportW = variant === 'mb' ? 343 : 1200;
    var exportH = variant === 'mb' ? 757 : 900;
    var wasDebug = stage.classList.contains('is-debug');
    var bgEl = card.querySelector('.csp-cred__bg');
    var mapEl = card.querySelector('.csp-cred__map');
    var prevBgVis = bgEl ? bgEl.style.visibility : '';
    var prevMapVis = mapEl ? mapEl.style.visibility : '';
    var prevCardBg = card.style.background;
    var mapBox = null;

    fillCredentialCard(card, firstName, email);
    stage.classList.add('is-capturing');
    card.classList.add('is-capture-target');

    return waitFontsReady()
      .then(function () {
        return waitImages(card);
      })
      .then(function () {
        // 等一帧，保证 is-capturing 布局稳定后再量地图位置
        return new Promise(function (resolve) {
          window.requestAnimationFrame(function () {
            resolve();
          });
        });
      })
      .then(function () {
        // MB 为 height:auto，按实际渲染高度导出，才能带上 frame 底 padding
        var measuredH = Math.ceil(Math.max(card.scrollHeight || 0, card.offsetHeight || 0));
        if (measuredH > 0) {
          exportH = variant === 'mb' ? Math.max(757, measuredH) : Math.max(900, measuredH);
        }
        if (mapEl) mapBox = relativeBox(mapEl, card);

        // 只隐藏像素、保留占位：不要用 filter 删掉 map，否则文字层会上移叠图
        if (bgEl) bgEl.style.visibility = 'hidden';
        if (mapEl) mapEl.style.visibility = 'hidden';
        card.style.background = 'transparent';

        return Promise.all([
          resolveDrawableImage(bgEl),
          resolveDrawableImage(mapEl),
          ensureHtmlToImage().then(function (htmlToImage) {
            return captureDomLayer(htmlToImage, card, {
              cacheBust: true,
              pixelRatio: 2,
              skipAutoScale: true,
              width: exportW,
              height: exportH,
              backgroundColor: null,
              style: {
                margin: '0',
                transform: 'none',
                background: 'transparent',
              },
            });
          }),
        ]);
      })
      .then(function (parts) {
        var bgBitmap = parts[0];
        var mapBitmap = parts[1];
        var textDataUrl = parts[2];
        if (!textDataUrl) throw new Error('Failed to export image');
        return composeCredentialPng(
          card,
          exportW,
          exportH,
          textDataUrl,
          bgBitmap,
          mapBitmap,
          mapBox,
          variant === 'mb' ? 12 : 4
        );
      })
      .then(function (result) {
        if (typeof result === 'string') {
          downloadDataUrl(result, 'chicago-star-passport.png');
        } else {
          downloadBlob(result, 'chicago-star-passport.png');
        }
      })
      .finally(function () {
        if (bgEl) bgEl.style.visibility = prevBgVis;
        if (mapEl) mapEl.style.visibility = prevMapVis;
        card.style.background = prevCardBg;
        card.classList.remove('is-capture-target');
        stage.classList.remove('is-capturing');
        if (wasDebug) stage.classList.add('is-debug');
      });
  }

  function showCspToast(message) {
    var toast = document.getElementById('simple-toast');
    if (toast && typeof toast.show === 'function') {
      toast.show(message);
      return;
    }
    window.alert(message);
  }

  /**
   * 调试：页面上展示 PC + MB 两张凭证 HTML。
   * 用法：控制台执行 cspShowCredentials('Keihen', 'a@b.com')
   * 关闭：cspHideCredentials()
   */
  function showCredentialDebug(firstName, email) {
    var stage = document.querySelector('[data-csp-credential-stage]');
    if (!stage) {
      logWarn('凭证 stage 未找到');
      return null;
    }
    var name = firstName != null ? String(firstName) : 'Keihen';
    var mail = email != null ? String(email) : 'cofikel550@94an.com';
    stage.querySelectorAll('[data-csp-credential]').forEach(function (card) {
      fillCredentialCard(card, name, mail);
    });
    stage.classList.add('is-debug');
    stage.setAttribute('aria-hidden', 'false');
    log('凭证调试预览已打开', { firstName: name, email: mail });
    return stage;
  }

  function hideCredentialDebug() {
    var stage = document.querySelector('[data-csp-credential-stage]');
    if (!stage) return;
    stage.classList.remove('is-debug');
    stage.setAttribute('aria-hidden', 'true');
    log('凭证调试预览已关闭');
  }

  window.cspShowCredentials = showCredentialDebug;
  window.cspHideCredentials = hideCredentialDebug;

  function collectDraftFromForm(form, api, meta) {
    var interests = [];
    form.querySelectorAll('[name="interests"]:checked').forEach(function (cb) {
      interests.push(cb.value);
    });
    return {
      first_name: (form.querySelector('[name="first_name"]') || {}).value || '',
      last_name: (form.querySelector('[name="last_name"]') || {}).value || '',
      phone: (form.querySelector('[name="phone"]') || {}).value || '',
      birthday: api.datepicker.getValue(),
      gender: api.gender.getValue(),
      interests: interests,
      consent_join: !!(form.querySelector('[data-csp-consent="join"]') || {}).checked,
      consent_terms: !!(form.querySelector('[data-csp-consent="terms"]') || {}).checked,
      consent_marketing: !!(form.querySelector('[data-csp-consent="marketing"]') || {}).checked,
      registerOk: !!(meta && meta.registerOk),
      isExistingMember: !!(meta && meta.isExistingMember),
      part1Complete: !!(meta && meta.part1Complete),
      part2Complete: !!(meta && meta.part2Complete),
      part3Complete: !!(meta && meta.part3Complete),
      updatedAt: Date.now(),
    };
  }

  function applyDraft(form, api, draft, preferMemberFields) {
    if (!draft) return;
    log('应用本机草稿', draft);
    var first = form.querySelector('[name="first_name"]');
    var last = form.querySelector('[name="last_name"]');
    var phone = form.querySelector('[name="phone"]');
    if (first && (!preferMemberFields || !first.value)) first.value = draft.first_name || first.value;
    if (last && (!preferMemberFields || !last.value)) last.value = draft.last_name || last.value;
    if (phone && (!preferMemberFields || !phone.value)) {
      phone.value = formatUsPhoneForField(draft.phone || phone.value);
    }

    if (!preferMemberFields || !api.datepicker.getValue()) {
      var birth = parseBirthDate(draft.birthday);
      if (birth) api.datepicker.setValue(birth, { keepOpen: true });
    }
    if (!preferMemberFields || !api.gender.getValue()) {
      if (draft.gender) api.gender.setValue(draft.gender);
    }
    if (!preferMemberFields) {
      applyInterests(form, draft.interests || []);
    } else {
      var checked = form.querySelectorAll('[name="interests"]:checked');
      if (!checked.length && draft.interests && draft.interests.length) {
        applyInterests(form, draft.interests);
      }
    }
    if (typeof draft.consent_join === 'boolean') setConsentChecked(form, 'join', draft.consent_join);
    if (typeof draft.consent_terms === 'boolean') setConsentChecked(form, 'terms', draft.consent_terms);
    if (typeof draft.consent_marketing === 'boolean') setConsentChecked(form, 'marketing', draft.consent_marketing);
  }

  function fillEmpty(el, value) {
    if (!el) return;
    if (String(el.value || '').trim()) return;
    if (value == null || value === '') return;
    el.value = value;
  }

  /** 会员信息晚到时合并：不覆盖用户已填内容 */
  function mergeMemberIntoForm(profileForm, api, member) {
    var form = profileForm.querySelector('[data-csp-profile-submit]');
    if (!form || !member) return;
    log('后台会员信息回填（仅空字段）', member.email);
    fillEmpty(form.querySelector('[name="first_name"]'), member.first_name || '');
    fillEmpty(form.querySelector('[name="last_name"]'), member.last_name || '');
    fillEmpty(form.querySelector('[name="phone"]'), formatUsPhoneForField(member.mobile_phone || ''));
    if (!api.gender.getValue() && member.gender) api.gender.setValue(member.gender);
    if (!api.datepicker.getValue()) {
      var birth = parseBirthDate(member.birth_date);
      if (birth) {
        api.datepicker.setValue(birth, { keepOpen: true, force: true });
        api.datepicker.setReadonly(true);
      }
    } else if (parseBirthDate(member.birth_date)) {
      api.datepicker.setReadonly(true);
    }
    var checked = form.querySelectorAll('[name="interests"]:checked');
    if (!checked.length) {
      var scenarios = (member.properties && member.properties.usage_scenario) || [];
      applyInterests(form, mapUsageScenariosToInterests(scenarios));
    }
  }

  function fillProfile(profileForm, api, member, email, draft) {
    var form = profileForm.querySelector('[data-csp-profile-submit]');
    if (!form) return;

    clearFormErrors(form);
    setEmailReadonly(form, email);

    if (member) {
      log('填充模式：会员', member.email);
      var first = form.querySelector('[name="first_name"]');
      var last = form.querySelector('[name="last_name"]');
      var phone = form.querySelector('[name="phone"]');
      if (first) first.value = member.first_name || '';
      if (last) last.value = member.last_name || '';
      if (phone) phone.value = formatUsPhoneForField(member.mobile_phone || '');
      api.gender.setValue(member.gender || '');
      var birth = parseBirthDate(member.birth_date);
      if (birth) {
        api.datepicker.setValue(birth, { keepOpen: true, force: true });
        api.datepicker.setReadonly(true);
        log('会员有生日，日期只读');
      } else {
        api.datepicker.clear();
        api.datepicker.setReadonly(false);
        log('会员生日为空，允许手动填写');
      }
      var scenarios = (member.properties && member.properties.usage_scenario) || [];
      applyInterests(form, mapUsageScenariosToInterests(scenarios));
      applyDraft(form, api, draft, true);
    } else {
      log('填充模式：非会员 / 先展开待查');
      var firstEmpty = form.querySelector('[name="first_name"]');
      var lastEmpty = form.querySelector('[name="last_name"]');
      var phoneEmpty = form.querySelector('[name="phone"]');
      if (firstEmpty) firstEmpty.value = '';
      if (lastEmpty) lastEmpty.value = '';
      if (phoneEmpty) phoneEmpty.value = '';
      api.gender.clear();
      api.datepicker.clear();
      api.datepicker.setReadonly(false);
      applyInterests(form, []);
      setConsentChecked(profileForm, 'join', true);
      setConsentChecked(profileForm, 'terms', true);
      setConsentChecked(profileForm, 'marketing', false);
      applyDraft(form, api, draft, false);
    }

    setConsentChecked(profileForm, 'join', true);
    setConsentChecked(profileForm, 'terms', true);
    if (member) {
      setConsentChecked(profileForm, 'marketing', !!(draft && draft.consent_marketing));
    }
  }

  function validateProfile(form, api) {
    clearFormErrors(form);
    var ok = true;
    var failed = [];
    ['first_name', 'last_name', 'email'].forEach(function (name) {
      var field = form.querySelector('[data-csp-field="' + name + '"]');
      var input = form.querySelector('[name="' + name + '"]');
      var empty = !input || !String(input.value || '').trim();
      if (name === 'email' && input && input.value) {
        empty = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(input.value).trim());
      }
      if (empty) {
        setFieldError(field, true);
        failed.push(FIELD_LABELS_ZH[name] || name);
        ok = false;
      }
    });
    if (api.datepicker && typeof api.datepicker.commitInput === 'function') {
      api.datepicker.commitInput();
    }
    if (!api.datepicker.getValue() || !parseBirthDate(api.datepicker.getValue())) {
      setFieldError(form.querySelector('[data-csp-field="birthday"]'), true);
      failed.push(FIELD_LABELS_ZH.birthday);
      ok = false;
    }
    var phoneInput = form.querySelector('[name="phone"]');
    var phoneRaw = phoneInput ? String(phoneInput.value || '').trim() : '';
    if (phoneRaw && !isUsPhoneNumber(phoneRaw)) {
      setFieldError(form.querySelector('[data-csp-field="phone"]'), true);
      failed.push(FIELD_LABELS_ZH.phone);
      ok = false;
    } else if (phoneInput && phoneRaw) {
      phoneInput.value = maskUsPhoneInput(phoneRaw);
    }
    if (!api.gender.getValue()) {
      setFieldError(form.querySelector('[data-csp-field="gender"]'), true);
      failed.push(FIELD_LABELS_ZH.gender);
      ok = false;
    }
    if (!form.querySelectorAll('[name="interests"]:checked').length) {
      setFieldError(form.querySelector('[data-csp-field="interests"]'), true);
      failed.push(FIELD_LABELS_ZH.interests);
      ok = false;
    }
    ['join', 'terms'].forEach(function (key) {
      var input = form.querySelector('[data-csp-consent="' + key + '"]');
      var err = form.querySelector('[data-csp-consent-error="' + key + '"]');
      if (!input || !input.checked) {
        if (err) err.removeAttribute('hidden');
        failed.push(FIELD_LABELS_ZH['consent_' + key] || key);
        ok = false;
      } else if (err) {
        err.setAttribute('hidden', '');
      }
    });
    var consentFailed = failed.some(function (item) {
      return item === FIELD_LABELS_ZH.consent_join || item === FIELD_LABELS_ZH.consent_terms;
    });
    var alertWrap = form.closest('[data-csp-profile-form]');
    var alert = alertWrap ? alertWrap.querySelector('[data-csp-profile-alert]') : null;
    if (!ok && alert) {
      var alertText = alert.querySelector('.csp-profile__alert-text');
      if (alertText) {
        alertText.textContent = consentFailed && failed.length <= 2
          ? 'Please agree to the required terms to continue.'
          : 'Please complete the required information.';
      }
      alert.removeAttribute('hidden');
      try {
        alert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch (e) { /* ignore */ }
    }
    if (!ok) logWarn('校验未通过', failed);
    else log('校验通过');
    return ok;
  }

  function collectProfilePayload(form, api) {
    var interests = [];
    form.querySelectorAll('[name="interests"]:checked').forEach(function (cb) {
      interests.push(cb.value);
    });
    return {
      email: String((form.querySelector('[name="email"]') || {}).value || '').trim(),
      first_name: String((form.querySelector('[name="first_name"]') || {}).value || '').trim(),
      last_name: String((form.querySelector('[name="last_name"]') || {}).value || '').trim(),
      phone: (function () {
        var raw = String((form.querySelector('[name="phone"]') || {}).value || '').trim();
        return isUsPhoneNumber(raw) ? maskUsPhoneInput(raw) : raw;
      }()),
      birthday: formatApiDate(api.datepicker.getValue()),
      gender: api.gender.getValue(),
      interests: interests,
    };
  }

  function setSubmitting(profileForm, submitBtn, on) {
    if (profileForm) {
      profileForm.classList.toggle('is-submitting', on);
      profileForm.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    setButtonLoading(submitBtn, on);
    log(on ? '提交 Loading 开始：表单已锁定' : '提交 Loading 结束：表单已解锁');
  }

  function setSubmitStatus(el, text, type) {
    if (!el) return;
    if (!text) {
      el.setAttribute('hidden', '');
      el.textContent = '';
      el.classList.remove('is-error', 'is-success');
      return;
    }
    el.textContent = text;
    el.classList.toggle('is-error', type === 'error');
    el.classList.toggle('is-success', type === 'success');
    el.removeAttribute('hidden');
  }

  function initCspTerms(root) {
    var termsEl = root.querySelector('[data-csp-terms]');
    var termsOpen = root.querySelector('[data-csp-terms-open]');
    var termsClose = root.querySelector('[data-csp-terms-close]');
    if (!termsEl || !termsOpen) return;

    function isOpen() {
      return termsEl.hasAttribute('open');
    }

    function openTerms() {
      termsEl.setAttribute('open', '');
      termsEl.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('csp-terms-open');
    }

    function closeTerms() {
      termsEl.removeAttribute('open');
      termsEl.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('csp-terms-open');
    }

    var consentLabel = termsOpen.closest('.csp-consent');
    if (consentLabel) {
      consentLabel.addEventListener('click', function (event) {
        if (event.target.closest('[data-csp-terms-open]')) {
          event.preventDefault();
        }
      }, true);
    }

    termsOpen.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openTerms();
    });

    if (termsClose) {
      termsClose.addEventListener('click', function (event) {
        event.preventDefault();
        closeTerms();
      });
    }

    termsEl.addEventListener('click', function (event) {
      if (event.target === termsEl) closeTerms();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) {
        event.preventDefault();
        closeTerms();
      }
    });
  }

  function initCsp(root) {
    if (!root || root.dataset.cspReady === 'true') return;
    root.dataset.cspReady = 'true';
    log('初始化 CSP', root.id);

    var campaignEnded = applyCampaignEndedGate(root);

    var cta = root.querySelector('[data-csp-cta]');
    var panel = root.querySelector('[data-csp-panel]');
    if (!cta || !panel) return;

    var mq = window.matchMedia('(max-width: 749px)');
    function isMobile() {
      return mq.matches;
    }
    function setPanelOpen(open) {
      root.classList.toggle('is-panel-open', open);
      panel.setAttribute('aria-hidden', isMobile() ? (open ? 'false' : 'true') : 'false');
    }
    setPanelOpen(false);
    syncHeaderHeight();

    cta.addEventListener('click', function (event) {
      event.preventDefault();
      pushGa4SelectContent('Start_the_Journey');
      if (isMobile()) {
        setPanelOpen(true);
        return;
      }
      setPanelOpen(false);
      window.scrollTo({
        top: panel.getBoundingClientRect().top + window.pageYOffset,
        behavior: 'smooth',
      });
    });
    window.addEventListener('resize', syncHeaderHeight);

    var stepsEl = root.querySelector('[data-csp-steps]');
    function setCurrentStep(step) {
      if (!stepsEl) return;
      var current = Math.max(1, Math.min(4, Number(step) || 1));
      stepsEl.setAttribute('data-csp-current-step', String(current));
      stepsEl.querySelectorAll('[data-csp-step]').forEach(function (item) {
        var n = Number(item.getAttribute('data-csp-step'));
        var done = n < current;
        item.classList.toggle('is-active', n === current);
        item.classList.toggle('is-done', done);
        var pending = item.querySelector('.csp-steps__glyph--pending');
        var doneGlyph = item.querySelector('.csp-steps__glyph--done');
        if (pending) {
          if (done) pending.setAttribute('hidden', '');
          else pending.removeAttribute('hidden');
        }
        if (doneGlyph) {
          if (done) doneGlyph.removeAttribute('hidden');
          else doneGlyph.setAttribute('hidden', '');
        }
      });
    }
    root.cspSetCurrentStep = setCurrentStep;

    var card1 = root.querySelector('[data-csp-card-1]');
    var profileForm = root.querySelector('[data-csp-profile-form]');
    var emailForm = root.querySelector('[data-csp-email-form]');
    var emailError = root.querySelector('[data-csp-email-error]');
    var datepickerEl = root.querySelector('[data-csp-datepicker]');
    var genderEl = root.querySelector('[data-csp-gender]');
    var submitForm = root.querySelector('[data-csp-profile-submit]');
    var submitBtn = root.querySelector('[data-csp-profile-submit-btn]');
    var submitStatus = root.querySelector('[data-csp-submit-status]');

    var api = {
      datepicker: datepickerEl ? initDatepicker(datepickerEl) : null,
      gender: genderEl ? initGender(genderEl) : null,
    };

    var phoneInputEl = root.querySelector('[data-csp-field="phone"] [name="phone"]');
    if (phoneInputEl) {
      phoneInputEl.addEventListener('input', function () {
        var masked = maskUsPhoneInput(phoneInputEl.value);
        applyMaskedInputValue(phoneInputEl, masked, true);
        setFieldError(phoneInputEl.closest('[data-csp-field="phone"]'), false);
      });
      phoneInputEl.addEventListener('blur', function () {
        var raw = String(phoneInputEl.value || '').trim();
        if (!raw) {
          setFieldError(phoneInputEl.closest('[data-csp-field="phone"]'), false);
          return;
        }
        if (isUsPhoneNumber(raw)) {
          phoneInputEl.value = maskUsPhoneInput(raw);
          setFieldError(phoneInputEl.closest('[data-csp-field="phone"]'), false);
          return;
        }
        setFieldError(phoneInputEl.closest('[data-csp-field="phone"]'), true);
      });
    }

    var state = {
      checkedEmail: '',
      registerOk: false,
      isExistingMember: false,
      memberInfoPromise: null,
      checkSeq: 0,
      formOpened: false,
      part1Complete: false,
      part2Complete: false,
      part3Complete: false,
    };

    var draftTimer = null;
    function scheduleDraftSave() {
      if (!state.checkedEmail || !submitForm) return;
      clearTimeout(draftTimer);
      draftTimer = setTimeout(function () {
        saveDraft(
          state.checkedEmail,
          collectDraftFromForm(submitForm, api, state)
        );
      }, 300);
    }

    function syncProgressFromDraft(draft) {
      state.part1Complete = !!(draft && draft.part1Complete);
      state.part2Complete = !!(draft && draft.part2Complete);
      state.part3Complete = !!(draft && draft.part3Complete);
    }

    function persistProgress(extra) {
      if (!state.checkedEmail) return;
      var base = submitForm
        ? collectDraftFromForm(submitForm, api, state)
        : {
            part1Complete: state.part1Complete,
            part2Complete: state.part2Complete,
            part3Complete: state.part3Complete,
          };
      mergeAndSaveDraft(state.checkedEmail, Object.assign({}, base, extra || {}));
    }

    function tryRestoreProgress(email) {
      var draft = loadDraft(email);
      if (!draft || !draft.part1Complete) return false;
      syncProgressFromDraft(draft);
      if (profileForm) {
        setEmailReadonly(profileForm, email);
        if (draft.first_name) {
          var firstInput = profileForm.querySelector('[name="first_name"]');
          if (firstInput) firstInput.value = draft.first_name;
        }
      }
      return restoreProgressFromDraft(
        root,
        card1,
        profileForm,
        draft,
        setCurrentStep,
        function () {
          openCredentialPopup(root, profileForm, state);
        }
      );
    }

    function openFormForEmail(email, member) {
      if (tryRestoreProgress(email)) {
        state.formOpened = false;
        log('本机已有进度，跳过表单展开');
        return;
      }
      var draft = loadDraft(email);
      syncProgressFromDraft(draft);
      expandProfile(card1, profileForm);
      fillProfile(profileForm, api, member || null, email, draft);
      state.formOpened = true;
      scheduleDraftSave();
    }

    /** 表单展开后立即后台注册；失败不挡填写，提交时再兜底 */
    function kickoffRegisterAfterExpand(email, seq) {
      if (!email || state.isExistingMember || state.registerOk) return;
      log('表单已展开，同步发起注册…', email);
      registerWithRetry(email, REGISTER_MAX_TRIES)
        .then(function (reg) {
          if (seq !== state.checkSeq) return null;
          if (!reg || !reg.ok) {
            logWarn('展开后注册未成功，提交时会再试', reg);
            return null;
          }
          state.registerOk = true;
          log('展开后注册完成');
          return ShokzMember.getMemberInfoByEmail(email);
        })
        .then(function (infoRes) {
          if (!infoRes || seq !== state.checkSeq) return;
          applyLateMemberInfo(infoRes, email, seq);
        })
        .catch(function (err) {
          if (seq !== state.checkSeq) return;
          logError('展开后注册异常，提交时会再试', err);
        });
    }

    function applyLateMemberInfo(res, email, seq) {
      if (seq !== state.checkSeq) return;
      log('迟到的 member-info 结果', res);
      var isMember = ShokzMember.hasMemberInfoPayload(res);
      var member = isMember ? (res.data || res.info || null) : null;
      state.isExistingMember = isMember;
      if (isMember) state.registerOk = true;
      if (isMember && state.formOpened) {
        mergeMemberIntoForm(profileForm, api, member);
        scheduleDraftSave();
      }
    }

    if (emailForm && card1 && profileForm && api.datepicker && api.gender) {
      emailForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (campaignEnded || isCampaignEnded(root)) {
          applyCampaignEndedGate(root);
          return;
        }
        var input = emailForm.querySelector('input[name="email"]');
        var btn = emailForm.querySelector('.csp-email__btn');
        var email = input ? String(input.value || '').trim() : '';
        log('—— Check Email ——', email);
        if (emailError) {
          emailError.setAttribute('hidden', '');
          emailError.textContent = '';
        }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          if (emailError) {
            emailError.textContent = 'Please enter a valid email.';
            emailError.removeAttribute('hidden');
          }
          return;
        }

        pushGa4SelectContent('Check_Email');

        state.checkSeq += 1;
        var seq = state.checkSeq;
        state.checkedEmail = email;
        state.registerOk = false;
        state.isExistingMember = false;
        state.formOpened = false;
        state.memberInfoPromise = null;
        state.part1Complete = false;
        state.part2Complete = false;
        state.part3Complete = false;

        setButtonLoading(btn, true);
        log('Check Email loading，最长等待 ' + CHECK_EMAIL_TIMEOUT_MS + 'ms');

        try {
          var memberPromise = ShokzMember.getMemberInfoByEmail(email);
          state.memberInfoPromise = memberPromise;

          memberPromise
            .then(function (res) {
              applyLateMemberInfo(res, email, seq);
            })
            .catch(function (err) {
              if (seq !== state.checkSeq) return;
              logError('member-info 请求失败', err);
            });

          var raced = await raceWithTimeout(memberPromise, CHECK_EMAIL_TIMEOUT_MS);
          if (seq !== state.checkSeq) return;

          if (raced.timedOut) {
            logWarn('3 秒内未确认会员状态，展开表单并同步注册');
            openFormForEmail(email, null);
            kickoffRegisterAfterExpand(email, seq);
            return;
          }

          if (raced.error) {
            logError('查会员异常，展开表单并同步注册', raced.error);
            openFormForEmail(email, null);
            kickoffRegisterAfterExpand(email, seq);
            return;
          }

          var res = raced.value;
          log('member-info 在时限内返回', res);
          var isMember = ShokzMember.hasMemberInfoPayload(res);
          var member = isMember ? (res.data || res.info || null) : null;
          state.isExistingMember = isMember;
          state.registerOk = isMember;
          openFormForEmail(email, member);
          if (isMember) {
            log('已是会员，表单已回填');
          } else {
            log('非会员，表单已展开；同步注册，提交时若仍非会员再注册');
            kickoffRegisterAfterExpand(email, seq);
          }
        } catch (err) {
          if (seq !== state.checkSeq) return;
          logError('Check Email 异常，展开表单并同步注册', err);
          openFormForEmail(email, null);
          kickoffRegisterAfterExpand(email, seq);
        } finally {
          if (seq === state.checkSeq) setButtonLoading(btn, false);
        }
      });
    }

    if (submitForm && api.datepicker && api.gender) {
      submitForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        setSubmitStatus(submitStatus, '', '');
        if (campaignEnded || isCampaignEnded(root)) {
          applyCampaignEndedGate(root);
          return;
        }
        if (!validateProfile(submitForm, api)) return;

        setSubmitting(profileForm, submitBtn, true);
        var submittedOk = false;
        try {
          var email = state.checkedEmail || String((submitForm.querySelector('[name="email"]') || {}).value || '').trim();
          var filledBirthday = parseBirthDate(api.datepicker.getValue());

          log('提交前再次查询是否会员…');
          var infoRes = null;
          try {
            infoRes = await ShokzMember.getMemberInfoByEmail(email);
          } catch (checkErr) {
            logError('提交前查会员异常', checkErr);
          }

          var isMember = ShokzMember.hasMemberInfoPayload(infoRes);
          var member = isMember ? (infoRes.data || infoRes.info || null) : null;

          if (!isMember) {
            log('提交时仍非会员，开始注册…');
            var reg = await registerWithRetry(email, REGISTER_MAX_TRIES);
            if (!reg.ok) {
              setSubmitStatus(submitStatus, 'Registration failed. Please try again.', 'error');
              return;
            }
            state.registerOk = true;
            log('注册完成，再次验会员…');
            infoRes = await ShokzMember.getMemberInfoByEmail(email);
            isMember = ShokzMember.hasMemberInfoPayload(infoRes);
            member = isMember ? (infoRes.data || infoRes.info || null) : null;
            if (!isMember) {
              setSubmitStatus(submitStatus, 'Member verification failed. Please try again.', 'error');
              logWarn('注册后仍非会员', infoRes);
              return;
            }
          }

          state.isExistingMember = true;
          state.registerOk = true;

          var payload = collectProfilePayload(submitForm, api);
          var memberBirth = member ? parseBirthDate(member.birth_date) : null;

          if (memberBirth) {
            if (filledBirthday && !birthdaysEqual(filledBirthday, memberBirth)) {
              log('生日与会员系统不一致，改用会员生日', toApiDate(filledBirthday), '→', toApiDate(memberBirth));
              showCspToast("We're using the birthday from your member account.");
            }
            payload.birthday = toApiDate(memberBirth);
            api.datepicker.setValue(memberBirth, { keepOpen: true, force: true });
            api.datepicker.setReadonly(true);
          } else {
            log('会员无生日，沿用用户填写');
          }

          var auth = await fetchProfileToken();
          await pushChicagoProfile(auth, payload);

          state.part1Complete = true;
          state.part2Complete = false;
          state.part3Complete = false;
          persistProgress({
            part1Complete: true,
            part2Complete: false,
            part3Complete: false,
            email: email,
          });
          submittedOk = true;
          enterPart2(root, card1, profileForm, setCurrentStep);
          log('资料提交成功');
        } catch (err) {
          logError('资料提交失败', err);
          setSubmitStatus(
            submitStatus,
            (err && err.message) || 'Submit failed. Please try again.',
            'error'
          );
        } finally {
          setSubmitting(profileForm, submitBtn, false);
          if (!submittedOk) scheduleDraftSave();
          pushGa4Subscribe(submittedOk ? 'success' : 'fail', 'Unlock_Your_2nd_Star');
        }
      });

      submitForm.addEventListener('input', scheduleDraftSave);
      submitForm.addEventListener('change', function () {
        scheduleDraftSave();
        ['join', 'terms'].forEach(function (key) {
          var input = submitForm.querySelector('[data-csp-consent="' + key + '"]');
          var err = submitForm.querySelector('[data-csp-consent-error="' + key + '"]');
          if (input && input.checked && err) err.setAttribute('hidden', '');
        });
      });
    }

    var part2Cta = root.querySelector('[data-csp-part2-cta]');
    if (part2Cta) {
      part2Cta.addEventListener('click', function (event) {
        if (campaignEnded || isCampaignEnded(root)) {
          event.preventDefault();
          applyCampaignEndedGate(root);
          return;
        }
        pushGa4SelectContent('Open_Shokzusa');
        state.part1Complete = true;
        state.part2Complete = true;
        persistProgress({
          part1Complete: true,
          part2Complete: true,
        });
        completePart2(root, setCurrentStep);
      });
    }

    var part3Cta = root.querySelector('[data-csp-part3-cta]');
    if (part3Cta) {
      part3Cta.addEventListener('click', async function (event) {
        if (part3Cta.classList.contains('loading')) {
          event.preventDefault();
          return;
        }
        if (state.part3Complete) {
          completePart3(root, setCurrentStep, function () {
            openCredentialPopup(root, profileForm, state);
          });
          return;
        }
        if (campaignEnded || isCampaignEnded(root)) {
          event.preventDefault();
          applyCampaignEndedGate(root);
          return;
        }

        var email = String(state.checkedEmail || '').trim();
        if (!email && profileForm) {
          var emailInput = profileForm.querySelector('[name="email"]');
          if (emailInput) email = String(emailInput.value || '').trim();
        }
        if (!email) {
          showCspToast('Please enter your email first.');
          return;
        }

        pushGa4SelectContent('Open_Post');

        setButtonLoading(part3Cta, true);
        try {
          try {
            var auth = await fetchProfileToken();
            await pushChicagoOfflineEvent(auth, email);
            log('Part 3 offline-event 推送成功');
          } catch (pushErr) {
            logError('Part 3 offline-event 失败（仍推进进度）', pushErr);
          }

          state.part1Complete = true;
          state.part2Complete = true;
          state.part3Complete = true;
          persistProgress({
            part1Complete: true,
            part2Complete: true,
            part3Complete: true,
            email: email,
          });
          completePart3(root, setCurrentStep, function () {
            openCredentialPopup(root, profileForm, state);
          });
        } finally {
          setButtonLoading(part3Cta, false);
        }
      });
    }

    var popupSave = root.querySelector('[data-csp-popup-save]');
    if (popupSave) {
      popupSave.addEventListener('click', function (event) {
        event.preventDefault();
        if (popupSave.disabled) return;

        pushGa4SelectContent('Save_Confirmation_Image');

        var firstName = '';
        var email = state.checkedEmail || '';
        if (profileForm) {
          var firstInput = profileForm.querySelector('[name="first_name"]');
          var emailInput = profileForm.querySelector('[name="email"]');
          if (firstInput) firstName = String(firstInput.value || '').trim();
          if (!email && emailInput) email = String(emailInput.value || '').trim();
        }

        setButtonLoading(popupSave, true);
        saveCredentialImage(root, firstName, email)
          .then(function () {
            log('凭证图片已下载', {
              mobile: isMobileViewport(),
              firstName: firstName,
              email: email,
            });
          })
          .catch(function (err) {
            logError('凭证图片下载失败', err);
            showCspToast('Failed to save confirmation image. Please try again.');
          })
          .then(function () {
            setButtonLoading(popupSave, false);
          });
      });
    }

    var popupHub = root.querySelector('.csp-popup__hub');
    if (popupHub) {
      popupHub.addEventListener('click', function () {
        pushGa4SelectContent('Go_to_ShokzSquad_Hub');
      });
    }

    initCspTerms(root);

    log('CSP 初始化完成');
  }

  function initAll() {
    syncHeaderHeight();
    bindCspKeyboardViewport();
    document.querySelectorAll('[data-csp]').forEach(initCsp);
    try {
      var params = new URLSearchParams(window.location.search || '');
      if (params.get('csp-cred-debug') === '1') {
        showCredentialDebug(
          params.get('csp-cred-name') || 'Keihen',
          params.get('csp-cred-email') || 'cofikel550@94an.com'
        );
      }
    } catch (e) { /* ignore */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
